import { gql } from '@apollo/client';

export const PROJECT_PAGE_FRAGMENT = gql`
  fragment ProjectPageFragment on ProjectPage {
    id
    databaseId
    title
    tiptapContent
    shared
    shareUrl
    lastEditedBy {
      id
      databaseId
      name
      avatarUrl
    }
    createdAt
    updatedAt
  }
`;
